import { AnswerTypeEnum } from "../enums/answerTypeEnums";

export const QuestionResponseTypeMapping = {
  [AnswerTypeEnum.LIKERT]: "Express emotions",
  [AnswerTypeEnum.LIKERT_NA]: "Express emotions with N/A",
  [AnswerTypeEnum.VRIDDHI]: "Vriddhi Framework",
  [AnswerTypeEnum.STRING]: "Free text field",
} as const;

export const RESPONSE_TYPE_LIST = [
  { id: 1, key: AnswerTypeEnum.LIKERT, value: "Express emotions" },
  { id: 2, key: AnswerTypeEnum.LIKERT_NA, value: "Express emotions with NA" },
  {
    id: 3,
    key: AnswerTypeEnum.VRIDDHI,
    value: "Vriddhi Framework",
  },
  { id: 4, key: AnswerTypeEnum.STRING, value: "Free text field" },
];

export const QUESTION_TYPE_LIST = [
  { id: 1, key: 'PEER_FEEDBACK', value: 'Peer Feedback' },
  { id: 2, key: 'SELF_ASSESSMENT', value: 'Self Assessment' },
];
